 import { computed } from "vue";


export const  staffSummaryMeta= (state)=>{
    return computed(() => {
        return state.staffSummaryMeta
      })
  
     
}